export const OFF_CHAIN_VERIFYING_CONTRACT_ADDRESS = '0xCcCCccccCCCCcCCCCCCcCcCccCcCCCcCcccccccC';
export const ON_CHAIN_VERIFYING_CONTRACT_ADDRESS = '0x6F7a338F2aA472838dEFD3283eB360d4Dff5D203';
export const VAULT_CONTRACT_ADDRESS = '0x816f722424B49Cf1275cc86DA9840Fbd5a6167e9';
